var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-form-msg"},[_vm._v(" "+_vm._s(_vm.countOptions.prefix)+" "),_c('span',{class:{ red: _vm.countOptions.order === 'desc', blue: _vm.countOptions.order !== 'desc' },style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.countOptions.count)+" ")]),_vm._v(" "+_vm._s(_vm.countOptions.suffix)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }